
export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide to ensure maximum privacy and security.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast Speed',
      description: 'Experience blazing-fast connection speeds with our optimized server network. Stream, browse, and download without any lag or buffering delays.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Connect to servers across multiple countries and regions. Access content from anywhere in the world with our extensive global infrastructure.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'No-Log Policy',
      description: 'We never track, collect, or share your private data. Your online activities remain completely anonymous and secure with our strict no-logging policy.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices with a single account. Compatible with Windows, macOS, iOS, Android, and Linux operating systems for comprehensive coverage.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Customer Support',
      description: 'Our dedicated support team is available around the clock to assist you. Get help whenever you need it through multiple communication channels.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Powerful Features
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our VPN solution combines advanced security features with user-friendly design to deliver the ultimate protection for your digital life.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-purple-600 rounded-xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
